module.exports = __webpack_public_path__ + "static/media/yx_banner.15f7f2c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/yx_banner.jpg
// module id = 1579
// module chunks = 10